import { ReactElement, ReactNode } from 'react'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { Button, ButtonProps } from '@mui/material'

interface Props extends ButtonProps {
  children?: ReactNode
}

const HideButton = ({
  children = 'verstecken',
  variant = 'outlined',
  ...props
}: Props): ReactElement => (
  <Button variant={variant} startIcon={<VisibilityOff />} {...props}>
    {children}
  </Button>
)

export default HideButton
